import React from 'react'
import { Image, Link, CtaArrow } from 'newComponents'

import './styles.scss'

const ArticleGrid = ({ data }) => {
  const {
    primary: { title, tagline },
    items
  } = data

  const RenderCaseStudiesArticles = ({ url, content }) => {
    const { company_name: companyName, headline, logo } = content

    return (
      <Link to={url} className="article-grid-item">
        <div className="card card-style article-grid-item-inner">
          <Image className="article-grid-item-logo" image={logo} />
          <h5 className="article-grid-item-headline">{headline.text}</h5>
          <span className="article-grid-item-link-text">
            {companyName} Case Study <CtaArrow />
          </span>
        </div>
      </Link>
    )
  }

  const RenderAricles = ({ type, url, content }) => {
    if (type === 'case_studies') {
      return <RenderCaseStudiesArticles url={url} content={content} />
    }
    return null
  }

  return (
    <section className="article-grid">
      <div className="article-grid-inner container">
        <div className="article-grid-header-container">
          {title && <div dangerouslySetInnerHTML={{ __html: title.html }} className="article-grid-title" />}
          {tagline && <div dangerouslySetInnerHTML={{ __html: tagline.html }} className="article-grid-tagline" />}
        </div>
        <div className="article-grid-items">
          {items.map((item) => {
            const {
              link_to_article: {
                type,
                url,
                document: { data }
              }
            } = item

            return (
              <div className="article-grid-item" key={url}>
                <RenderAricles type={type} url={url} content={data} />
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default ArticleGrid
